import React from 'react'
import classNames from 'classnames'
import { BasicCarousel } from '@/molecules/BasicCarousel'
import { DocumentCard } from '@/molecules/DocumentCard'
import { Downloadable } from '@/services/DownloadablesService'
import { AnalyticsEvent, useSafeTrack } from '@/utils/analytics'

interface DocumentScrollerProps {
  authenticated: boolean
  downloadables: Downloadable[]
  project: string
  returnTo: string
  wrapperClassName?: string
  padding?: boolean
  className?: string
  cardClassName?: string
  imageClassName?: string
  customTrackEventName?: AnalyticsEvent
}

export const DocumentScroller: React.FC<DocumentScrollerProps> = ({
  authenticated,
  downloadables,
  project,
  returnTo,
  padding = false,
  className,
  cardClassName,
  imageClassName,
  customTrackEventName,
}) => {
  const track = useSafeTrack()
  return (
    <BasicCarousel containerClassName={classNames({ 'px-4 sm:px-8 md:px-12 xl:px-16': padding }, className)}>
      {downloadables.map((downloadable) => {
        const handleDownloadableClick = () => {
          track(customTrackEventName || 'Downloadable Clicked', {
            project_slug: project,
            title: downloadable.title,
            type: downloadable.type,
          })
        }

        return (
          <DocumentCard
            authenticated={authenticated}
            key={downloadable.href}
            onClick={handleDownloadableClick}
            returnTo={returnTo}
            className={cardClassName}
            imageClassName={imageClassName}
            {...downloadable}
          />
        )
      })}
    </BasicCarousel>
  )
}
